import React, { useState, useEffect } from "react";
import { Box, Button, Typography, Link, IconButton, Chip, Avatar } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import bkstApi from "../../common/component/api";
import Staff from "../../staff/screen/Staff";
import ClickToCopy from "../../common/component/ClickToCopy";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import DataObjectIcon from "@mui/icons-material/DataObject";
import EditIcon from "@mui/icons-material/Edit";

export default function BakerStaff(props) {
  const { acctId } = props;

  const [staff, setStaff] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    bkstApi(`/admin/baker/${acctId}/staff`).then((res) => {
      setStaff(res.data.staff);
    });
  };

  const sortStaff = (o1, o2) => {
    let rank = o2.role?.localeCompare(o1.role);
    if (rank === 0) {
      rank = o2.firstName.localeCompare(o1.firstName);
    }
    return rank;
  };

  const columns = [
    {
      field: "photo",
      headerName: "Photo",
      width: 60,
      sortable: false,
      renderCell: (params) => (
        <Avatar src={`https://storage.googleapis.com/bakestreet-f55a0.appspot.com/img/u/${params.row.uid}.webp`} sx={{ width: 32, height: 32 }} />
      )
    },
    {
      field: "name",
      headerName: "Name",
      width: 200,
      valueGetter: (params) => `${params.row.firstName} ${params.row.lastName}`
    },
    {
      field: "role",
      headerName: "Role",
      width: 150,
      renderCell: (params) => <Chip size="small" label={params.row.role} />
    },
    {
      field: "accessCode",
      headerName: "Access Code",
      width: 150,
      renderCell: (params) =>
        params.row.accessCode ? (
          <Chip size="small" label={params.row.accessCode} />
        ) : (
          <Typography variant="body2" color="textSecondary">
            -
          </Typography>
        )
    },
    {
      field: "status",
      headerName: "Status",
      width: 120,
      renderCell: (params) => <Chip size="small" label={params.row.status} color={params.row.status === "inactive" ? "error" : "success"} />
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 120,
      sortable: false,
      renderCell: (params) => (
        <Box>
          <Staff
            siteId={acctId}
            value={params.row}
            onChange={(o) => getData()}
            disabled={params.row.email?.includes("pos.") || params.row.email?.includes("kds.")}
          >
            <IconButton size="small" disabled={params.row.email?.includes("pos.") || params.row.email?.includes("kds.")}>
              <EditIcon />
            </IconButton>
          </Staff>
          <ClickToCopy icon={FingerprintIcon} text={params.row.uid} />
          <IconButton
            size="small"
            component="a"
            target="_blank"
            href={`https://console.firebase.google.com/project/bakestreet-f55a0/firestore/data/~2Fbaker~2F${acctId}~2Fstaff~2F${params.row.uid}`}
          >
            <DataObjectIcon />
          </IconButton>
        </Box>
      )
    }
  ];

  const rows = staff.sort(sortStaff).map((staffMember, index) => ({
    id: staffMember.uid || index,
    ...staffMember
  }));

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, mt: 2 }}>
        <Typography variant="h2" component="h2">
          Staff
        </Typography>
        <Staff siteId={acctId} value={""} onChange={(o) => getData()}>
          <Button variant="contained">ADD</Button>
        </Staff>
      </Box>
      <Box sx={{ height: 800, width: "100%" }}>
        <DataGrid rows={rows} columns={columns} pageSize={25} rowsPerPageOptions={[5, 10, 25]} disableSelectionOnClick density="compact" />
      </Box>
    </Box>
  );
}
